const problemas = [
  { icon: 'ri-error-warning-line', text: 'Pagando impostos em excesso' },
  { icon: 'ri-error-warning-line', text: 'Sem controle real dos números' },
  { icon: 'ri-error-warning-line', text: 'Exposta a riscos fiscais ocultos' },
  { icon: 'ri-error-warning-line', text: 'Decisões sem base confiável' },
];

const solucoes = [
  { icon: 'ri-check-double-line', text: 'Diagnóstico completo da situação fiscal' },
  { icon: 'ri-check-double-line', text: 'Identificação de erros e oportunidades' },
  { icon: 'ri-check-double-line', text: 'Plano de ação personalizado' },
  { icon: 'ri-check-double-line', text: 'Sem custo, sem compromisso' },
];

export default function FolderDiagnostico() {
  return (
    <div
      className="relative overflow-hidden flex flex-col"
      style={{
        width: '390px',
        height: '693px',
        background: '#ffffff',
      }}
    >
      {/* Top gold stripe */}
      <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c]" />

      {/* Left navy sidebar */}
      <div className="absolute top-0 left-0 w-[6px] h-full bg-[#0f2651]" />

      {/* Decorative circle bg */}
      <div className="absolute bottom-[-80px] right-[-80px] w-64 h-64 rounded-full bg-[#0f2651]/5" />
      <div className="absolute bottom-[-40px] right-[-40px] w-40 h-40 rounded-full bg-[#c9a84c]/10" />

      <div className="relative z-10 flex flex-col h-full pl-10 pr-8 py-7">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-[#0f2651] font-bold text-2xl tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>RCP</div>
            <div className="text-[#c9a84c] text-[8px] font-bold tracking-[0.2em] uppercase mt-0.5">Inteligência Contábil &amp; Tributária</div>
          </div>
          <div className="text-right">
            <div className="text-gray-300 text-[7px] tracking-widest uppercase">CRC RS</div>
            <div className="text-[#c9a84c] text-[9px] font-bold">011307/O-2</div>
          </div>
        </div>

        {/* Hero image */}
        <div className="rounded-xl overflow-hidden mb-4" style={{ height: '140px', flexShrink: 0 }}>
          <img
            src="https://public.readdy.ai/ai/img_res/d44d206cc13329829ec3e4fccc8bc2c7.jpg"
            alt="Diagnóstico Gratuito RCP"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Badge */}
        <div className="inline-flex items-center gap-1.5 bg-[#0f2651] rounded-full px-3 py-1 mb-3 self-start">
          <div className="w-3 h-3 flex items-center justify-center text-[#c9a84c]">
            <i className="ri-gift-line text-[10px]" />
          </div>
          <span className="text-white text-[9px] font-bold tracking-widest uppercase">100% Gratuito</span>
        </div>

        <h2 className="text-[#0f2651] font-bold leading-tight mb-1" style={{ fontSize: '18px', fontFamily: 'Georgia, serif' }}>
          Sua empresa tem problemas<br />
          <span className="text-[#c9a84c]">fiscais sem saber?</span>
        </h2>
        <p className="text-gray-400 text-[9px] leading-relaxed mb-3">
          Faça um diagnóstico gratuito e descubra como otimizar sua situação tributária.
        </p>

        {/* Two columns */}
        <div className="grid grid-cols-2 gap-2 mb-4">
          {/* Problems */}
          <div>
            <div className="text-[9px] font-bold text-gray-400 uppercase tracking-widest mb-2">Sintomas comuns</div>
            <div className="space-y-1.5">
              {problemas.map((p) => (
                <div key={p.text} className="flex items-start gap-1.5">
                  <div className="w-3.5 h-3.5 flex items-center justify-center text-rose-400 flex-shrink-0 mt-0.5">
                    <i className={`${p.icon} text-[9px]`} />
                  </div>
                  <span className="text-gray-500 text-[8px] leading-tight">{p.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <div className="text-[9px] font-bold text-[#c9a84c] uppercase tracking-widest mb-2">O que fazemos</div>
            <div className="space-y-1.5">
              {solucoes.map((s) => (
                <div key={s.text} className="flex items-start gap-1.5">
                  <div className="w-3.5 h-3.5 flex items-center justify-center text-emerald-500 flex-shrink-0 mt-0.5">
                    <i className={`${s.icon} text-[9px]`} />
                  </div>
                  <span className="text-gray-600 text-[8px] leading-tight">{s.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="bg-[#f8f5ef] border-l-2 border-[#c9a84c] rounded-r-lg px-4 py-3 mb-4">
          <p className="text-[#0f2651] text-[10px] leading-relaxed italic">
            "Muitas empresas pagam mais impostos do que deveriam — e nem sabem disso."
          </p>
        </div>

        {/* CTA */}
        <div className="mt-auto">
          <div className="bg-[#0f2651] rounded-xl px-5 py-3 flex items-center justify-between mb-3">
            <div>
              <div className="text-white font-bold text-[11px] uppercase tracking-wide">Diagnóstico Gratuito</div>
              <div className="text-white/50 text-[9px] mt-0.5">Chame agora no WhatsApp</div>
            </div>
            <div className="bg-[#c9a84c] rounded-lg px-3 py-2 flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-[#0f2651] text-sm" />
              </div>
              <span className="text-[#0f2651] font-bold text-[10px] whitespace-nowrap">(51) 99100-3410</span>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-gray-300 text-[8px]">@inteligenciarcp</span>
            <span className="text-gray-300 text-[8px]">rcpinteligencia.com.br</span>
            <span className="text-gray-300 text-[8px]">Porto Alegre, RS</span>
          </div>
        </div>
      </div>
    </div>
  );
}
